import styled from "styled-components/macro";

export const TypographyTitleMediumElement = styled.h3`
  margin: 0;
  font-weight: 500;
  letter-spacing: 0.1px;
`;
